import Blockly from 'blockly/browser'
import { defineBlock, getOptionsCode } from '../Util'
import Mutators from '../Mutators'

const httpOptionsMutator = 'sirenia_http_options_mutator'

Mutators.registerOptionsMutator(httpOptionsMutator, {
  credentials: {},
  headers: {},
  useragent: { type: 'String' },
  timeout: {},
  contenttype: { type: 'String' }
})

function defineHttpBlock(httpVerb) {
  defineBlock(
    'sirenia_api_http_' + httpVerb,
    {
      message0: `reply from http ${httpVerb} to %1`,
      args0: [
        {
          type: 'input_value',
          name: 'URL',
          check: 'String'
        }
      ],
      output: null,
      mutator: httpOptionsMutator,
      tooltip: `Issue an http ${httpVerb} request`,
      helpUrl: `http://sirenia.eu/product/configuration-interface/documentation/flows/#${httpVerb}`
    },
    function(block) {
      const urlCode =
        Blockly.JavaScript.valueToCode(block, 'URL', Blockly.JavaScript.ORDER_ATOMIC) || `''`
      const optionsObject = getOptionsCode(this.chosenProps, block)
      const code = `Http.${httpVerb}(${urlCode}, ${optionsObject})`
      return [code, Blockly.JavaScript.ORDER_ATOMIC]
    }
  )
}

defineHttpBlock('get')
defineHttpBlock('delete')

function defineDataHttpBlock(httpVerb) {
  defineBlock(
    'sirenia_api_http_' + httpVerb,
    {
      message0: `reply from http ${httpVerb} to %1 with data %2`,
      args0: [
        {
          type: 'input_value',
          name: 'URL',
          check: 'String'
        },
        {
          type: 'input_value',
          name: 'DATA',
          check: 'String',
          align: 'RIGHT'
        }
      ],
      output: null,
      mutator: httpOptionsMutator,
      tooltip: `Issue an http ${httpVerb} request`,
      helpUrl: `http://sirenia.eu/product/configuration-interface/documentation/flows/#${httpVerb}`
    },
    function(block) {
      const valueCode =
        Blockly.JavaScript.valueToCode(block, 'DATA', Blockly.JavaScript.ORDER_ATOMIC) || `''`
      const urlCode =
        Blockly.JavaScript.valueToCode(block, 'URL', Blockly.JavaScript.ORDER_ATOMIC) || `''`
      const optionsObject = getOptionsCode(this.chosenProps, block)
      const code = `Http.${httpVerb}(${urlCode}, ${valueCode}, ${optionsObject})`
      return [code, Blockly.JavaScript.ORDER_ATOMIC]
    }
  )
}

defineDataHttpBlock('post')
defineDataHttpBlock('put')
